import { render, staticRenderFns } from "./ICDCodes.vue?vue&type=template&id=564476db&scoped=true&"
import script from "./ICDCodes.vue?vue&type=script&lang=js&"
export * from "./ICDCodes.vue?vue&type=script&lang=js&"
import style0 from "./ICDCodes.vue?vue&type=style&index=0&id=564476db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564476db",
  null
  
)

export default component.exports